function isLoggedInUserSameAsCurrentUser({ state, output }) {
  let { user, currentUser } = state.get('client')
  if (currentUser && user._id === currentUser._id) {
    output.true()
  } else {
    output.false()
  }
}

isLoggedInUserSameAsCurrentUser.outputs = ['true', 'false']

export default isLoggedInUserSameAsCurrentUser



// WEBPACK FOOTER //
// ./src/modules/client/actions/isLoggedInUserSameAsCurrentUser.js